import React, { useEffect, useState, useRef } from 'react';
import { oneKlicks } from '../../SDK/oneclick';
import { Spinner } from 'react-bootstrap';
import InvoicePrint from './InvoicePrint';

const InvoiceReminder = () => {
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showView, setShowView] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const invoiceRef = useRef();

    useEffect(() => {
        fetchInvoice();
    }, []);

    const fetchInvoice = async () => {
        setLoading(true);
        try {
            const tableSchema = '';
            const tableName = 'invoices';
            const conditions = {
                status: "!paid"
            };
            const orderBy = 'id DESC';
            const search = {};
            const pagination = {};
            const margedata = [];

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("fetchInvoice response:", response);
            if (response.success && response.data.length > 0) {
                setInvoices(response.data);
            } else {
                console.error("Error fetching invoices:", response.message);
            }
        } catch (error) {
            console.error("Error fetching invoices:", error);
        } finally {
            setLoading(false);
        }
    };

    const openView = (invoice) => {
        setSelectedInvoice(invoice);
        setShowView(true);
    }

    const handleGeneratePDF = () => {
        invoiceRef.current.generatePDF();
      };



    return (
        <div>
            <table>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Client</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Due Date</th>
                        <th>Created At</th>
                        <th>Action</th>
                    </tr>
                </thead>
                {invoices.map((invoice) => (
                    <tbody>
                        <tr>
                            <td>{invoice.id}</td>
                            <td>{invoice.client}</td>
                            <td>{invoice.amount}</td>
                            <td>{invoice.status}</td>
                            <td>{invoice.dueDate}</td>
                            <td>{invoice.created_at}</td>
                            <td>
                                <button className='btn btn-primary mr-1'>Send Reminder</button>
                                <button className='btn btn-primary mr-1' onClick={handleGeneratePDF}>Generate PDF</button>
                                <button className='btn btn-primary' onClick={() => openView(invoice)}>View</button>
                            </td>
                        </tr>
                    </tbody>

                ))}
            </table>

            {showView && (
                <InvoicePrint Id={selectedInvoice.id} genaretpdf={true} uploadserver={true} />
            )}

        </div>
    );
};

export default InvoiceReminder;
